<template>
    <div>
        <div class="yl-flex">
            <DatePicker type="month" placeholder="请选择月份" v-model="dateTime" style="width: 200px;margin: 0 20px;"
                        @on-change="getList"></DatePicker>
            <Button class='ivu-btn-circle' type="primary" @click="save">布置任务</Button>
        </div>
        <div style="margin-top: 20px;">
            <Table size="small" :columns="columns" :data="data">
                <template slot-scope="{row, index}" slot="performance">
                    <Input v-model="data[index].achievement" style="width: 100px"/>
                </template>
                <template slot-scope="{row, index}" slot="door">
                    <Input v-model="data[index].view_nums" style="width: 60px"/>
                </template>
                <template slot-scope="{row, index}" slot="sign">
                    <Input v-model="data[index].sign_nums" style="width: 60px"/>
                </template>
            </Table>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {getDepartmentTaskList, saveDepartmentTask} from "../../api/task";

    export default {
        name: "TaskSet",
        components: {},
        data() {
            return {
				dateTime: '',
                columns: [{
                    title: '员工姓名',
                    key: 'name'
                },
                    {
                        title: '所属部门',
                        key: 'department_name'
                    },
                    {
                        title: '业绩任务',
                        slot: 'performance'
                    },
                    {
                        title: '上门任务',
                        slot: 'door'
                    },
                    {
                        title: '签约任务',
                        slot: 'sign'
                    },
                    {
                        title: '任务月份',
                        key: 'date_time'
                    }
                ],
                data: []
            }
        },
        computed: {
            ...mapGetters(['token', 'userInfo'])
        },
        mounted() {
			let date = new Date;
			let year = date.getFullYear();
			let month = date.getMonth()+1;
			month = (month<10 ? "0"+month:month);
			this.dateTime = (year.toString() + '-' + month.toString());
            this.getList();
        },
        methods: {
            async getList() {
                let that = this;
                let data = {dateTime: this.dateTime}
                data.token = this.token;
                let res = await getDepartmentTaskList(that, data);
                this.data = res.data.list;
            },
            save() {
            	let that = this;
            	that.throttle(async function () {
					let data = {dateTime: this.dateTime, list: that.data}
					data.token = this.token;
					let res = await saveDepartmentTask(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
					}
				}, 500)
            }
        }
    }
</script>

<style scoped lang="less">
    .yl-flex {
        display: flex;
        justify-content: flex-end;
        padding-bottom: 0;
    }

    .add_flex {
        display: flex;
        align-items: center;
        margin: 10px 0;
    }

    .add_title {
        margin: 0 10px;
        font-weight: bold;

    }

    .add_box {
        border: 1px solid #969696;
        padding: 10px;
    }
	/deep/ .ivu-table table {
		width: 100% !important;
	}
	
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}
	
	/deep/ .ivu-table .table-blue-row td {
		color: #FF6699;
	}
	
	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
	
	/deep/ .client_name {
		display: inline-block;
		margin: 0 4px;
		color: #85c7ff;
	}
</style>
